import { produce } from 'immer';

export const reorderOperation = (reorder, templates) => {
  const { fromId, toId } = reorder;

  if (!fromId || !toId || fromId === toId) return null;

  const activeTemplateIndex = templates.findIndex((t) => t.active === true);
  if (activeTemplateIndex === -1) return null;

  const updatedTemplates = produce(templates, (draft) => {
    const operations = draft[activeTemplateIndex].activityModel;
    const fromIndex = operations.findIndex((op) => op.id === fromId);
    const toIndex = operations.findIndex((op) => op.id === toId);

    if (fromIndex === -1 || toIndex === -1) return;

    const [moved] = operations.splice(fromIndex, 1);
    operations.splice(toIndex, 0, moved);
  });

  return { updatedTemplates, activeTemplateIndex };
};
